var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.apiError)?_c('div',{staticClass:"d-block text-center"},[_c('span',{staticClass:"text-danger"},[_vm._v("Erreur connexion serveur. Veuillez réessayer plus tard.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }